import { Skeleton as MuiSkeleton, Stack } from '@mui/material';
import { MainLogo } from '@/components/layout/header/components/main-logo';

export const HeaderSkeleton = () => (
  <Stack
    data-testid="header-skeleton"
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    width="100%"
  >
    <Stack direction="row" alignItems="center" gap={{ xs: 1, md: 3 }}>
      <MuiSkeleton
        variant="rounded"
        width={40}
        height={40}
        sx={{ display: { xs: 'block', lg: 'none' } }}
      />
      <MainLogo />
      <Stack
        direction="row"
        spacing={2}
        sx={{ display: { xs: 'none', lg: 'flex' } }}
      >
        {[1, 2, 3, 4].map((i) => (
          <MuiSkeleton key={i} variant="rounded" width={80} height={24} />
        ))}
      </Stack>
    </Stack>
    <Stack direction="row" spacing={{ sm: 1, lg: 3 }} alignItems="center">
      <MuiSkeleton variant="circular" width={40} height={40} />
    </Stack>
  </Stack>
);
